<p-toast [style]="{marginTop: '80px'}"></p-toast>

<div class="grid" style="max-width:1200px;margin:0 auto;">
  <div class="col">
    <div class="card">
      <h2 class="mt-3 mb-4">VRBO Logman Links</h2>

      <div class="grid">
        <div class="col-12">
          <p-table [value]="logmanLinks" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 200px;">Service</th>
                <th style="width: 300px;">All Property logman Link</th>
                <th style="width: 300px;">Property specific logman Link</th>
                <th style="width: 300px;">Postman Link</th>
                <th style="width: 100px;">Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-link>
              <tr>
                <td>
                  <strong>{{link.service}}</strong>
                </td>
                <td>
                  <a [href]="link.logmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                    {{link.logmanUrl}}
                  </a>
                </td>
                <td>
                  <a [href]="link.propertyLogmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                    {{link.propertyLogmanUrl}}
                  </a>
                </td>
                <td>
                  <a [href]="link.postmanUrl" target="_blank" rel="noopener noreferrer" class="text-primary">
                    {{link.postmanUrl}}
                  </a>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>
